import {
  FETCH_ADDITIONAL_FEES,
  FETCH_ADDITIONAL_FEES_SUCCESS,
  FETCH_ADDITIONAL_FEES_FAILED,
  EDIT_ADDITIONAL_FEE
} from "../store/types";

const INITIAL_STATE = {
  fees: [],
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const additionalfeesreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ADDITIONAL_FEES:
      return {
        ...state,
        loading: true
      };
    case FETCH_ADDITIONAL_FEES_SUCCESS:
      return {
        ...state,
        fees: action.payload,
        loading: false,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_ADDITIONAL_FEES_FAILED:
      return {
        ...state,
        fees: [],
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_ADDITIONAL_FEE:
      return state;
    default:
      return state;
  }
};
